
root = exports ? this

root.watchPaymentSession = (id, handler) ->
	getStatus = ->
		$.get('/payment-session-status', {id: id}, (data) ->
			handler(data)
			if data.status == 'done' or data.status == 'failed'
				clearInterval(interval)
		, 'json').fail(->
			panicDialog('Failed to get payment session status')
			clearInterval(interval)
		)
	#endfunc

	interval = setInterval(getStatus, 5000)
	getStatus()

root.doPaymentDialog = (uid, email, profileUrl, amount, currency, closable, isNew, mode = 'pay', withOnly = false) ->
	win = $('<div class="modal fade"><div class="modal-dialog modal-md"><div class="modal-content panel-info">
	<div class="modal-header panel-heading">
		'+(if closable then '<button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span></button>' else '')+'
		<h3 class="modal-title">'+(if mode == 'pay' then tr('Payment of %amount%', {'amount': formatMoney(amount, currency)}) else tr('Credit card update'))+'</h3>
	</div>
	<div class="modal-body">
		<div class="panel-group" id="doPayment_method">
			<div class="panel panel-default formPanel">
				<div class="panel-heading"
						data-toggle="collapse"
						data-parent="#doPayment_method"
						href="#doPayment_method_with">
					<span class="glyphicon glyphicon-credit-card"></span> '+tr('Credit card provided')+'
				</div>
				<ul class="panel-collapse collapse in list-group" id="doPayment_method_with">
					<form>
					<li class="list-group-item">
						<div class="row">
							<div class="col-sm-5"><strong>'+tr('Card number')+'</strong></div>
							<div class="col-sm-7"><input type="text" class="form-control" name="number" required autocomplete="off" pattern="[0-9]{4}[ -]?[0-9]{4}[ -]?[0-9]{4}[ -]?[0-9]{4}" /></div>
						</div>
					</li>
					<li class="list-group-item">
						<div class="row">
							<div class="col-sm-5"><strong>'+tr('Expiration date')+'</strong></div>
							<div class="col-sm-7">
								<div class="row">
									<div class="col-xs-6"><select name="expireMonth" class="form-control">
										<option value="1">01</option><option value="2">02</option><option value="3">03</option>
										<option value="4">04</option><option value="5">05</option><option value="6">06</option>
										<option value="7">07</option><option value="8">08</option><option value="9">09</option>
										<option value="10">10</option><option value="11">11</option><option value="12">12</option>
									</select></div>
									<div class="col-xs-6"><select name="expireYear" class="form-control">
										<option value="2014">2014</option><option value="2015">2015</option><option value="2016">2016</option>
										<option value="2017">2017</option><option value="2018">2018</option><option value="2019">2019</option>
										<option value="2020">2020</option><option value="2021">2021</option><option value="2022">2022</option>
										<option value="2023">2023</option><option value="2024">2024</option>
									</select></div>
								</div>
							</div>
						</div>
					</li>
					<li class="list-group-item">
						<div class="row">
							<div class="col-sm-5"><strong>'+tr('Card security code')+'</strong></div>
							<div class="col-sm-7"><input type="text" class="form-control" name="cvc" autocomplete="off" required pattern="[0-9]{3,4}" /></div>
							<input type="submit" class="hidden" />
						</div>
					</li>
					</form>
				</ul>
			</div>
			'+(if not withOnly then '<div class="panel panel-default">
				<div class="panel-heading"
						data-toggle="collapse"
						data-parent="#doPayment_method"
						href="#doPayment_method_without">
					<span class="glyphicon glyphicon-minus-sign"></span> '+tr('Credit card not provided')+'
				</div>
				<div id="doPayment_method_without" class="panel-collapse collapse">
					<div class="panel-body">
						<strong>'+(if mode == 'pay' then tr('Send a payment link to:') else tr('Send an update link to:'))+'</strong>
						<p><input class="form-control" type="email" name="email" /></p>
						<p class="sendLink"><button class="btn btn-primary"><span class="glyphicon glyphicon-envelope"></span> '+tr('Send link')+'</button></p>
						<p class="well" id="doPayment_sessionState"></p>
					</div>
				</div>
			</div>' else '')+'
		</div>
	</div>
	<div class="modal-footer">
		<button class="btn btn-default cancel" data-dismiss="modal"><span class="glyphicon glyphicon-remove"></span> '+tr('Cancel')+'</button>
		<button class="btn btn-success done"><span class="glyphicon glyphicon-ok"></span> '+tr('Terminate')+'</button>
	</div></div></div></div>')
	win.find('input[name=email]').val(email)

	win.find('#doPayment_method_without .sendLink button').click ->
		btn = $(this)
		btn.prop('disabled', true)
		btn.html('<span class="icon-spin3 animate-spin"></span> '+tr('Sending link…'))

		$.get(g_route_send_payment_link, {uid: uid, email: win.find('input[name=email]').val(), mode: mode, token: g_token}, (data) ->
			if data.result == 'ok'
				$('#doPayment_sessionState').css('display', 'block')
				watchPaymentSession(data.sessionId, (status) ->
					$('#doPayment_sessionState').text(status.text)
					if status.status in ['done', 'failed']
						isDone = true
						win.find('.modal-footer button.done').prop('disabled', false)
					if status.status == 'done'
						win.modal('hide')
						successPayment()
					#endif
				)
			else if data.result == 'mailFailed'
				alertDialog(tr('Send payment link'), tr('Invalid email address, please check it.'))
			else
				panicDialog('Failed to send payment link: unknown result \''+data.result+'\'')
			#endif
		, 'json').fail(->
			panicDialog('Failed to send payment link')
		).always(->
			btn.prop('disabled', false)
			btn.html('<span class="glyphicon glyphicon-envelope"></span> '+tr('Resend link'))
		)
	#endfunc

	isDone = false
	win.find('#doPayment_method_with').on('show.bs.collapse', ->
		win.find('.modal-footer button.done').prop('disabled', false)
	)
	win.find('#doPayment_method_with').on('hide.bs.collapse', ->
		win.find('.modal-footer button.done').prop('disabled', not isDone)
	)

	win.find('input[name=number]').payment('formatCardNumber')

	win.find('.modal-footer button.cancel').click ->
		if isNew
			document.location.href = g_route_newClient
		else
			win.modal('hide')
		#endif
	#endfunc

	win.find('.modal-footer button.done').click ->
		if win.find('#doPayment_method_with').hasClass('in')
			win.find('#doPayment_method_with form input[type=submit]').click()
		else if isDone
			document.location.href = g_route_newClient
			win.find('.modal-footer button').prop('disabled', true)
		#endif
	#endfunc

	successPayment = () ->
		if isNew
			btns = [
				{
					label: tr('View profile'),
					icon:  'glyphicon glyphicon-user',
					action: (dialog) ->
						document.location.href = profileUrl
				},
				{
					label: tr('New client'),
					cssClass: 'btn-success',
					icon:  'glyphicon glyphicon-plus',
					action: (dialog) ->
						document.location.href = g_route_newClient
				}
			]
		else
			btns = [
				{
					label: tr('Done'),
					cssClass: 'btn-success',
					icon:  'glyphicon glyphicon-ok',
					action: (dialog) ->
						document.location.href = profileUrl
				}
			]
		#endif
		BootstrapDialog.show({
			type:    BootstrapDialog.TYPE_SUCCESS,
			title:   if mode == 'pay' then tr('Congratulations %name%!', {'name': g_adminFirstName}) else tr('Credit card update'),
			message: if mode == 'pay' then tr('The payment for this client has been processed successfuly!') else tr('The credit card of this client has been updated.'),
			buttons: btns
		})

	win.find('#doPayment_method_with form').submit ->
		ccType = $.payment.cardType(win.find('input[name=number]').val())
#		if !$.payment.validateCardNumber(win.find('input[name=number]').val())
#			alertDialog(tr('Payment with card'), tr('Invalid credit card number.'))
#			return false
		if !$.payment.validateCardCVC(win.find('input[name=cvc]').val(), ccType)
			alertDialog(tr('Payment with card'), tr('Invalid credit card security code (CVV).'))
			return false

		win.find('.modal-footer button.done').prop('disabled', true)
		win.find('.modal-footer button.done span').replaceWith('<span class="icon-spin3 animate-spin"></span>')

		$.post(g_route_process_payment+'?uid='+uid+'&mode='+mode+'&token='+g_token, $(this).serialize(), (data) ->
			if data.result == 'ok'
				win.modal('hide')
				successPayment()
			else if data.result == 'willRetry'
				win.modal('hide')
				if isNew
					btns = [
						{
							label: tr('View profile'),
							icon:  'glyphicon glyphicon-user',
							action: (dialog) ->
								document.location.href = profileUrl
						},
						{
							label: tr('New client'),
							cssClass: 'btn-warning',
							icon:  'glyphicon glyphicon-plus',
							action: (dialog) ->
								document.location.href = g_route_newClient
						}
					]
				else
					btns = [
						{
							label: tr('Done'),
							cssClass: 'btn-warning',
							icon:  'glyphicon glyphicon-ok',
							action: (dialog) ->
								document.location.href = profileUrl
						}
					]
				#endif
				BootstrapDialog.show({
					type:    BootstrapDialog.TYPE_WARNING,
					title:   tr('Payment delayed'),
					message: tr('The payment failed due to insufficient funds on the client’s account. This payment will be automatically be retried every day by our system until it passes.'),
					buttons: btns
				})
			else if data.result == 'cardExists'
				alertDialog(tr('Credit card already registered'), tr('The credit card you entered is already registered for this client. If you want to retry this payment, please contact an administrator.'))
			else if data.result == 'duplicateCard'
				errorDialog(tr('Duplicated credit card'), tr('The credit card you entered is already associated with a client account. This incident will be reported.'))
			else if data.result == 'failed'
				if mode == 'pay'
					title = tr('Payment failed')
					msg   = tr('The payment failed, the system returned: (%code%) %message%.', {code: data.errorCode, message: data.errorMessage})
				else
					title = tr('Credit card update')
					msg   = tr('The credit card update failed, the system returned: (%code%) %message%.', {code: data.errorCode, message: data.errorMessage})
				#endif
				errorDialog(title, msg)
			else
				panicDialog('Failed to process payment, unknown result code \''+data.result+'\'')
			#endif
		#endfunc
		, 'json').fail(->
			panicDialog('Failed to process payment')
		).always(->
			win.find('.modal-footer button.done').prop('disabled', false)
			win.find('.modal-footer button.done span').replaceWith('<span class="glyphicon glyphicon-ok"></span>')
		)

		return false
	#endfunc

	if closable
		win.modal()
	else
		win.modal({backdrop: 'static', keyboard: false})
	#endif
